import { LazoThreadConversationStatus } from "@/enums/LazoThreadConversationStatus";
import Tenant from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/Tenant";
import { LazoChatMessage } from "@/models/ai-chat/LazoChatMessage";
import AuditableEntity from "@/types/AuditableEntity";
import { ConversationType } from "@/types/ConversationType";
import { ConversationMember } from "./ConversationMember";

export enum AVAILABLE_CONVERSATION_FILTERS {
  ALL = "all",
  MENTIONS = "mentions",
  TEAM = "team",
  ADMIN_READ_ONLY = "adminReadOnly",
}

export function mapToShell(c: LazoChatConversation): LazoChatConversationShell {
  return {
    ...c,
    membersCount: c.members ? c.members.length : 0,
    lastMessageText: c.messages ? c.messages[c.messages.length - 1]?.message || "" : "",
  };
}

export interface LazoChatConversationShell extends AuditableEntity {
  title?: string;
  membersCount: number;
  isOwner: boolean;
  isArchived?: boolean;
  unreadMessagesCount: number;
  conversationType?: ConversationType;
  tenant?: Tenant;
  hasChart?: boolean;
  internalChannelExternalId?: string;
  mentionsCount: number;
  readOnly?: boolean;
  lastMessageText: string;
  currentThreadStatus?: LazoThreadConversationStatus;
  currentThreadStarted?: Date;
  lastOpenTime?: Date;
  internalUnreadMessageCount?: number;
  externalMemberNames?: string;
  internalMemberNames?: string;
}

export interface LazoChatConversation extends AuditableEntity {
  messages: LazoChatMessage[];
  title?: string;
  members: ConversationMember[];
  isOwner: boolean;
  isArchived?: boolean;
  unreadMessagesCount: number;
  conversationType?: ConversationType;
  tenant?: Tenant;
  hasChart?: boolean;
  internalChannelExternalId?: string;
  mentionsCount: number;
  readOnly?: boolean;
}
